import React from 'react'
import { Checkbox } from 'react-md'

const CustomCheckbox = ({ input, meta: { touched, error }, ...rest }) => {
  return <Checkbox {...input} {...rest} checked={!!input.value} />
}

export default CustomCheckbox



// WEBPACK FOOTER //
// ./src/components/Checkbox/index.js